import { useState } from "react";
import { Button } from "./ui/button.jsx";

export default function ClientForm({ onSubmit, submitting }) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");

  function handleSubmit(e) {
    e.preventDefault();
    onSubmit({
      client_name: name,
      client_email: email,
      client_phone: phone
    });
  }

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <form onSubmit={handleSubmit} className="space-y-6">
        <div className="space-y-2">
          <label htmlFor="client-name" className="block text-sm font-medium text-white">
            Nome
          </label>
          <input
            id="client-name"
            type="text"
            required
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="w-full px-4 py-2 bg-background border border-border rounded-md text-white placeholder:text-muted focus:outline-none focus:ring-2 focus:ring-gold focus:border-transparent"
          />
        </div>

        <div className="space-y-2">
          <label htmlFor="client-email" className="block text-sm font-medium text-white">
            Email
          </label>
          <input
            id="client-email"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full px-4 py-2 bg-background border border-border rounded-md text-white placeholder:text-muted focus:outline-none focus:ring-2 focus:ring-gold focus:border-transparent"
          />
        </div>

        <div className="space-y-2">
          <label htmlFor="client-phone" className="block text-sm font-medium text-white">
            Telemóvel
          </label>
          <input
            id="client-phone"
            type="tel"
            required
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            className="w-full px-4 py-2 bg-background border border-border rounded-md text-white placeholder:text-muted focus:outline-none focus:ring-2 focus:ring-gold focus:border-transparent"
          />
        </div>

        <Button type="submit" className="w-full" size="lg" disabled={submitting}>
          {submitting ? "A confirmar..." : "Confirmar marcação"}
        </Button>
      </form>
    </div>
  );
}
